"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEvmTxFees = void 0;
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const api_1 = require("../../../../../api");
const bignumber_1 = require("../../../../utils/bignumber");
const constants_1 = require("../../../../utils/constants");
const constants_2 = require("../../constants");
const getEvmTxFees = async ({ adapter, sellAssetReference, buyAssetTradeFeeUsd, }) => {
    try {
        const gasFeeData = await adapter.getGasFeeData();
        // this is a good value to cover all thortrades out of EVMs
        // in the future we may want to look at doing this more precisely and in a future-proof way
        // TODO: calculate this dynamically
        const gasLimit = constants_2.THOR_EVM_GAS_LIMIT;
        const feeDataOptions = {
            fast: {
                txFee: (0, bignumber_1.bn)(gasLimit).times(gasFeeData[chain_adapters_1.FeeDataKey.Fast].gasPrice).toString(),
                chainSpecific: {
                    gasPrice: gasFeeData[chain_adapters_1.FeeDataKey.Fast].gasPrice,
                    gasLimit,
                },
            },
        };
        const feeData = feeDataOptions['fast'];
        return {
            networkFeeCryptoBaseUnit: feeData.txFee,
            chainSpecific: {
                estimatedGas: feeData.chainSpecific.gasLimit,
                gasPriceCryptoBaseUnit: feeData.chainSpecific.gasPrice,
                approvalFeeCryptoBaseUnit: sellAssetReference &&
                    (0, bignumber_1.bnOrZero)(constants_1.APPROVAL_GAS_LIMIT)
                        .multipliedBy((0, bignumber_1.bnOrZero)(feeData.chainSpecific.gasPrice))
                        .toString(),
            },
            buyAssetTradeFeeUsd,
            sellAssetTradeFeeUsd: '0',
        };
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[getThorTxInfo]', { cause: e, code: api_1.SwapErrorTypes.TRADE_QUOTE_FAILED });
    }
};
exports.getEvmTxFees = getEvmTxFees;
